module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-1e32d57ef942e19747e8f5b384e5b109.png";